export const msalConfig = {
   auth: {
      clientId: import.meta.env.VITE_OUTLOOK_CLIENT_ID,
      authority: import.meta.env.VITE_OUTLOOK_AUTHORITY,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
   },
   cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
   },
};
